<ca-avatar
  class="avatar"
  [image]="user().picture"
  [placeholder]="avatarPlaceholder()"
/>

@if (!isCollapsed()) {
  <div class="name">
    {{ user().first_name }} {{ user().last_name }}
  </div>

  <div class="email">
    {{ user().email }}
  </div>

  <mat-icon
    class="icon"
    svgIcon="arrow-up-down"
  />
}

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="overlayOrigin"
  [cdkConnectedOverlayOffsetY]="-4"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayMinWidth]="overlayOriginWidth"
  (overlayOutsideClick)="isOpen.set(false)"
>
  <div class="dropdown">
    <div class="actions">
      <ca-menu-item
        icon="log-out"
        [label]="'profileCard.logout' | translate"
        (click)="logout()"
      />
    </div>
  </div>
</ng-template>
